import type { RouteObject } from 'react-router-dom';

/**
 * Views 10 (boleta envelopes, D9) and 11 (folio usage, D10), «Emitir
 * boleta» (`boletas/new`): the emission shell with the boleta family fixed
 * (`docs/changes/2026-11-04-dte-emission-all-types`, REQ-024), and «Carga
 * masiva» (`boletas/import`, REQ-034).
 *
 * The «Boletas» menu destination (`boletas.nav.ts`) is visible: nothing in it
 * waits on the backend any more. `router.test.tsx` still demands that every
 * `NAV_UNFILTERED` destination resolve to a real route.
 */
export const boletasRoutes: RouteObject[] = [
  {
    path: 'boletas',
    lazy: () =>
      import('@/routes/pages/BoletasPage').then((m) => ({
        Component: m.BoletasPage,
      })),
  },
  {
    path: 'boletas/new',
    lazy: () =>
      import('@/routes/pages/DteCreatePage').then((m) => ({
        Component: m.BoletaCreatePage,
      })),
  },
  {
    path: 'boletas/import',
    lazy: () =>
      import('@/routes/pages/BoletaImportPage').then((m) => ({
        Component: m.BoletaImportPage,
      })),
  },
  {
    path: 'consumo-folios',
    lazy: () =>
      import('@/routes/pages/ConsumoFoliosPage').then((m) => ({
        Component: m.ConsumoFoliosPage,
      })),
  },
];
